export default "../images/stackloans-partners-with-NetCredit_New_PORTAL_US.png?78c8fb95710d470df6f8d85aaccab2fd";